export const initAccountPaymentsPayouts = () => {
  const paymentsPayoutsPage = document.getElementById("payments-payouts") as HTMLDivElement;

  if (!paymentsPayoutsPage) {
    return;
  }

  const dateFilterForm = paymentsPayoutsPage.querySelector(".date-filter-form") as HTMLFormElement;
  const dateFromFilter = paymentsPayoutsPage.querySelector(
    ".date-selector-from",
  ) as HTMLInputElement;
  const dateToFilter = paymentsPayoutsPage.querySelector(".date-selector-to") as HTMLInputElement;
  const loadOverlay = paymentsPayoutsPage.querySelector(".loader-overlay") as HTMLDivElement;

  const updateAction = () => {
    loadOverlay.classList.remove("d-none");

    dateFilterForm.submit();

    dateFromFilter.readOnly = true;
    dateToFilter.readOnly = true;
  };

  dateFromFilter.addEventListener("change", () => {
    updateAction();
  });

  dateToFilter.addEventListener("change", () => {
    updateAction();
  });
};
